var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#384047",
    d: "M17.709 8.875V4.51a.501.501 0 0 0 .102-.306.594.594 0 0 0-.368-.592L9.486.061a.562.562 0 0 0-.51 0L1.06 3.631a.568.568 0 0 0-.368.572c.02.245.184.47.408.55l2.653.899V9.1c0 .204.102.387.265.51a.57.57 0 0 0 .571.061 13.447 13.447 0 0 1 9.365 0c.062.02.143.04.225.04.122 0 .245-.04.347-.101a.638.638 0 0 0 .265-.51V5.652l1.714-.572v3.816a1.41 1.41 0 0 0-.796 1.265 1.41 1.41 0 0 0 1.408 1.407c.755 0 1.408-.652 1.408-1.407a1.499 1.499 0 0 0-.816-1.286z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.183a5cb6cfb8c0f777d15a044c32cb38.svg";
export { ForwardRef as ReactComponent };